module.exports = __webpack_public_path__ + "img/38476-004.7503c65f.jpg";